import { render, staticRenderFns } from "./confirmUserModal.vue?vue&type=template&id=2caa34f4&scoped=true"
import script from "./confirmUserModal.vue?vue&type=script&lang=js"
export * from "./confirmUserModal.vue?vue&type=script&lang=js"
import style0 from "./confirmUserModal.vue?vue&type=style&index=0&id=2caa34f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa34f4",
  null
  
)

export default component.exports